import { $delegate } from 'fxdom/es';
import { go } from 'fxjs/es';
import { pushLoginStack } from '../../../../../Creator/Login/F/fs.js';
import { MarketplaceAuthF } from '../../../../../Marketplace/Auth/F/Function/module/MarketplaceAuthF.js';
import { UtilS } from '../../../../../Util/S/Function/module/UtilS.js';
import { MShopShareFramePopUpF } from '../../../../ShareFrame/PopUp/F/Function/module/MShopShareFramePopUpF.js';
import { MShopUtilF } from '../../../../Util/F/Function/module/MShopUtilF.js';
import { MShopAppHomeF } from '../../../Home/F/Function/module/MShopAppHomeF.js';
import { MShopAppMypageMuiS } from '../../S/Mui/module/MShopAppMypageMuiS.js';
import { openMyAccountNess } from '../Function/openMyAccount.js';
import { Header } from '@services/MarppleShop/renderApp/components/cells/Header/Global/Header.ts';
import { LayoutView } from '../../../../../../services/MarppleShop/renderApp/components/cells/Layout/LayoutView.ts';

/*
 * 프론트에서 사용될 tab 옵션입니다.
 * https://www.notion.so/marpple/Marpple-UI-80875a30a63e436382a02e2d820f4695#2fecac9aa5f8457c92fa359c5ac71ef8
 * */

export const tab = {
  ...MShopAppMypageMuiS.tab,
  inner_scroll_target: '', // modal 일때 이너 스크롤 엘리먼트 셀렉터
  makeData(tab) {}, // template 함수 인자에 들어갈 값을 리턴하는 함수,
  appending(tab_el) {}, // tab 엘리먼트가 만들어지면 울리는 함수
  appended(tab_el) {}, // tab 엘리먼트가 html에 붙으면 울리는 함수
  showing(tab_el) {}, // tab 엘리먼트 show하기 전 울리는 함수
  showed(tab_el) {}, // tab 엘리먼트 show하고 나서 울리는 함수
  rendered(tab_el) {
    MShopAppHomeF.checkAppLoginPoint();
    MShopUtilF.hydrationRune(Header, LayoutView);

    return go(
      tab_el,
      $delegate('click', '.mypage-main-login__btn_login', (e) => {
        if (MShopUtilF.isApp()) return pushLoginStack();

        MarketplaceAuthF.goSignIn();
      }),
      $delegate('click', '.mypage-main-login__btn_join', (e) => {
        if (MShopUtilF.isApp()) return pushLoginStack(true);

        MarketplaceAuthF.goSignUp();
      }),
      $delegate('click', '.mypage-main-login__btn_apply_seller', (e) => {
        if (!MShopUtilF.isApp()) {
          location.href = `/${T.lang}/@/hello`;
          return;
        }

        e.originalEvent.preventDefault();
        MShopUtilF.postMessage({
          navigate: {
            name: 'SignUpSeller',
            params: {
              title: T('mshop::QuickMenu::t1'),
              uri: `/${T.lang}/@/hello`,
            },
          },
        });
      }),
      $delegate('click', '.mypage-menu__item--btn_cart', (e) => {
        if (!MShopUtilF.isApp()) return;

        e.originalEvent.preventDefault();
        MShopUtilF.postMessage({
          navigate: {
            sel: 'PaymentStackNavigation.Cart',
            params: {
              previousRouteName: 'Mypage',
            },
          },
        });
      }),
      $delegate('click', '.mypage-user__btn_studio', (e) => {
        if (!MShopUtilF.isApp()) return;

        e.originalEvent.preventDefault();
        MShopUtilF.postMessage({
          navigate: {
            sel: 'SellerStudioScreen',
            params: { uri: `/${T.lang}/${box.sel('is_user->_->store->domain_name')}/settings` },
          },
        });
      }),
      $delegate('click', '.mypage-menu__item--btn_guide', (e) => {
        if (T.lang == 'kr') {
          MShopShareFramePopUpF.alert({
            title: '사이트 이용 시 유의사항',
            body: `
              이 사이트의 콘텐츠에 대한 모든 권리와 의무는<br>
              저작권자 또는 제공처에 있습니다.<br>
              이를 무단 사용 및 도용할 경우 저작권법 등에 따라<br>
              법적 책임을 질 수 있습니다.<br>
              크리에이터의 저작물(콘텐츠)에 대한 문제 발생 시<br>
              마플샵은 이에 대한 책임을 지지 않습니다.
            `,
          });
        } else if (T.lang == 'jp') {
          MShopShareFramePopUpF.alert({
            title: 'サイトのご利用上の注意',
            body: `
                このサイトのコンテンツに関するすべての権利と疑問は著作権者又提供先であり、
                無断でご使用する場合、著作権法によって法的な責任を負うことになります。
                クリエイターの著作物（コンテンツ）に対した問題は発生した場合、
                弊社MarppleShopは一切の責任を負いかねますのであらかじめご了承ください。
            `,
          });
        } else {
          MShopShareFramePopUpF.alert({
            title: 'Precautions',
            body: `
              All rights and obligations for the contents of this site belong to the copyright holder or the provider,
              so if you use or steal them without permission, you may be liable according to copyright laws, etc.
              In the event of a problem with the seller's work (content), MarppleShop is not responsible for this.
            `,
          });
        }
      }),
      $delegate('click', '.mypage-user__btn_account_set, .mypage-user__pic', async (e) => {
        if (UtilS.isNessApp()) {
          e.originalEvent.preventDefault();
          await openMyAccountNess();
        }
      }),
    );
  }, // tab 에 관련된 모든 메소드와 엘리먼트 작업이 끝날때 울리는 함수

  hiding(tab_el, v) {}, // tab이 가려지기 전 울리는 함수
  hided(tab_el, v) {}, // tab이 가려진 후 울리는 함수
  removing(tab_el, v) {}, // tab이 삭제되기 전 울리는 함수
  removed(tab_el, v) {}, // tab이 삭제된 후 울리는 함수

  infinite(tab_el) {}, // tab 엘리먼트에 무한스크롤을 사용할때 쓰는 함수, 사용시 반드시 return MuiF.tabInfinite(...)
};
